/** Maximum date range supported by the time-series chart API and date picker. */
export const MAX_DATE_RANGE_DAYS = 31;
